import { Dropdown } from "@screencloud/screencloud-ui-components";
import { type InjectedIntlProps, injectIntl } from "react-intl";
import type { ShippingService } from "../../../hooks/usePixiWizardState";
import { Field, FieldRow } from "../styles";

export interface ShippingMethodFieldProps {
  value: ShippingService;
  onChange: (service: ShippingService) => void;
}

/**
 * Shipping-service (Standard / Express) dropdown rendered as the last field of
 * the Shipping Information form, half-width to match the City field. The choice
 * is passed to the Checkout step, which resolves the matching shipping rate.
 */
const ShippingMethodFieldBase = ({
  value,
  onChange,
  intl,
}: ShippingMethodFieldProps & InjectedIntlProps) => {
  const options = [
    {
      key: "standard",
      value: "standard",
      text: intl.formatMessage({
        id: "pixi_wizard.payment_shipping.shipping_method.standard",
        defaultMessage: "Standard",
      }),
    },
    {
      key: "express",
      value: "express",
      text: intl.formatMessage({
        id: "pixi_wizard.payment_shipping.shipping_method.express",
        defaultMessage: "Express",
      }),
    },
  ];

  return (
    <FieldRow>
      <Field>
        <Dropdown
          fluid
          selection
          name="shippingService"
          options={options}
          value={value}
          onChange={(_event, data) => onChange(data.value as ShippingService)}
          data-testid="shipping-method-select"
        />
      </Field>
      <Field aria-hidden="true" />
    </FieldRow>
  );
};

export const ShippingMethodField = injectIntl(ShippingMethodFieldBase);
